import { Link } from '@tanstack/react-router';
import { ArrowLeft, ArrowRight, ShieldAlert } from 'lucide-react';
import { Logo } from '../../components/Logo';
import { useActiveBrand } from '../../api/brand';

/**
 * 403 Forbidden — §10
 */
export function Forbidden() {
  const brand = useActiveBrand();
  return (
    <div className="min-h-screen bg-marketing dark:bg-marketing-dark flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md text-center">
        <div className="flex flex-col items-center mb-7">
          <span
            aria-hidden="true"
            className="mono text-[88px] sm:text-[120px] leading-none font-semibold tracking-tighter text-zinc-200 dark:text-zinc-800 select-none"
          >
            403
          </span>
        </div>

        <div className="w-12 h-12 mx-auto -mt-12 mb-5 grid place-items-center rounded-full bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-700 shadow-sm text-amber-600 dark:text-amber-400 relative">
          <ShieldAlert className="w-5 h-5" />
        </div>

        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-950 dark:text-zinc-50">
          You don't have permission.
        </h1>
        <p className="mt-3 text-sm text-zinc-600 dark:text-zinc-300 max-w-sm mx-auto">
          Your role doesn't include access to this page. If you think this is a mistake, ask
          the business admin to grant you access.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-brand text-white shadow-xs hover:bg-brand-hover dark:bg-brand-dm dark:text-zinc-950 dark:hover:bg-brand-dm-hover transition"
          >
            Go to dashboard
            <ArrowRight className="w-4 h-4" />
          </Link>
          <button
            type="button"
            onClick={() => history.back()}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium text-zinc-900 dark:text-zinc-50 border border-zinc-300 dark:border-zinc-700 bg-white/60 dark:bg-zinc-900/60 hover:bg-white dark:hover:bg-zinc-900 transition"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        </div>

        <p className="mt-8 text-xs text-zinc-500 dark:text-zinc-400">
          Need help?{' '}
          <a
            href={`mailto:${brand.supportEmail}`}
            className="text-brand dark:text-brand-dm hover:underline"
          >
            Contact support
          </a>
        </p>

        <div className="mt-8 flex items-center justify-center gap-2 text-xs text-zinc-500 dark:text-zinc-400">
          <Logo className="w-5 h-5 rounded-md" />
          <span>{brand.name}</span>
        </div>
      </div>
    </div>
  );
}
